import { useQuery } from "@tanstack/react-query";

import { getClosedToday } from "@/api/production-api";
import type { ClosedTodayResponse } from "@/schemas";
import { useTenantTimezone } from "@/hooks/use-tenant-timezone";

const REFETCH_INTERVAL = 5 * 1000; // 5 seconds

export const useCartonsClosedToday = (machineId?: string) => {
	const { data: tenantTimezone } = useTenantTimezone();

	const timezone = tenantTimezone?.siteTimeZone || "UTC";

	const queryFn = () => getClosedToday(machineId, timezone);

	const { data, isLoading, error, refetch } = useQuery<ClosedTodayResponse>({
		queryKey: ["closed-today", machineId, timezone],
		queryFn,
		refetchInterval: REFETCH_INTERVAL,
	});

	return {
		data,
		isLoading,
		error,
		refetch,
	};
};
